import { render, staticRenderFns } from "./ApplicationsDetail.vue?vue&type=template&id=86c096d2&scoped=true"
import script from "./ApplicationsDetail.vue?vue&type=script&lang=js"
export * from "./ApplicationsDetail.vue?vue&type=script&lang=js"
import style0 from "./ApplicationsDetail.vue?vue&type=style&index=0&id=86c096d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c096d2",
  null
  
)

export default component.exports